export const environment = {
  production: false,
  useEmulators: false,
  firebase: {
    apiKey: 'AIzaSyAvRaofQG8fi1DR2Mdk-u1IEZ4rJ303oeI',
    authDomain: 'taperzone-staging.firebaseapp.com',
    projectId: 'taperzone-staging',
    storageBucket: 'taperzone-staging.firebasestorage.app',
    messagingSenderId: '478577899045',
    appId: '1:478577899045:web:0c37efd91f91e25ed431cc',
  },
  // TODO: replace with live price IDs before going to production
  billingPriceIds: {
    athleteMonthly: 'price_1TRDskLSmXiVvoouHV5tePPf',
    athleteAnnual: 'price_1TRDskLSmXiVvoouxHrxx4Gl',
    coachBaseMonthly: 'price_1TRDwMLSmXiVvoouJxpgeG2u',
    coachBaseAnnual: 'price_1TRDwMLSmXiVvoouRgOIHnVu',
  },
};
